<template>
  <ui-auth
    key="changePassword"
    id="changePassword"
    :success="onSuccess"
    :fail="onFail"
  />
</template>

<script>
// Ui
import UiAuth from 'components/Auth';

export default {
  name: 'view-profile-change-password',

  // Components
  components: {
    UiAuth,
  },

  // Methods
  methods: {
    onSuccess() {
      localStorage.setItem('changePasswordSuccess', true);
      this.$router.push({ name: 'profile' });
    },

    onFail(error) {
      console.error('Password change failed', error);
    },
  },
};
</script>



// WEBPACK FOOTER //
// Change.vue?92b5458c